export const ENTITY = 'SOATO';
